import { Link } from "react-router-dom";
import { Eye, Users, Lock, CheckCircle2, Clock } from "lucide-react";
import { resolveImg, fmtMoney } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function InfoCard({ info, index = 0 }) {
  const { site } = useAuth();
  const cur = site?.currency || "₺";
  return (
    <Link
      to={`/info/${info.id}`}
      data-testid="info-card-item"
      className="cx-card rounded-2xl overflow-hidden flex flex-col group cx-fade-up"
      style={{ animationDelay: `${index * 90}ms` }}
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-slate-900">
        {info.image_url ? (
          <img src={resolveImg(info.image_url)} alt={info.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
        ) : (
          <div className="h-full w-full cx-grid-bg flex items-center justify-center"><Lock className="h-10 w-10 text-slate-700" /></div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-[#05070D] via-transparent to-transparent" />
        {info.category && (
          <span className="absolute top-3 left-3 font-mono-cx text-[10px] uppercase tracking-widest px-2 py-1 rounded-md bg-slate-950/80 border border-cyan-500/40 text-cyan-300">{info.category}</span>
        )}
        <span data-testid="info-card-viewers" className="absolute top-3 right-3 inline-flex items-center gap-1.5 text-[11px] font-semibold px-2 py-1 rounded-md bg-slate-950/80 border border-slate-700 text-slate-200">
          <span className="cx-live-dot" /> {info.viewers} kişi inceliyor
        </span>
        {info.is_free && (
          <span data-testid="info-card-free-badge" className="absolute bottom-3 right-3 inline-flex items-center gap-1 text-[11px] font-bold px-2 py-1 rounded-md bg-emerald-500 text-[#05070D]">ÜCRETSİZ</span>
        )}
        {info.purchased && !info.is_free && (
          <span className="absolute bottom-3 left-3 inline-flex items-center gap-1 text-[11px] font-semibold px-2 py-1 rounded-md bg-emerald-950/90 border border-emerald-500/50 text-emerald-300">
            <CheckCircle2 className="h-3 w-3" /> Satın alındı
          </span>
        )}
        {!info.purchased && info.payment_status === "pending" && (
          <span className="absolute bottom-3 left-3 inline-flex items-center gap-1 text-[11px] font-semibold px-2 py-1 rounded-md bg-amber-950/90 border border-amber-500/50 text-amber-300">
            <Clock className="h-3 w-3" /> Onay bekliyor
          </span>
        )}
      </div>
      <div className="p-5 flex flex-col gap-3 flex-1">
        <h3 className="font-display text-lg font-semibold text-slate-50 leading-snug">{info.title}</h3>
        <p className="text-sm text-slate-400 line-clamp-2">{info.preview}</p>
        <div className="mt-auto pt-3 flex items-center justify-between border-t border-slate-800/80">
          <div className="flex items-center gap-1.5 text-xs text-slate-400" data-testid="info-card-buyers">
            <Users className="h-3.5 w-3.5 text-cyan-400" /> {info.buyers_count} kişi satın aldı
          </div>
          <span className="font-display font-bold text-cyan-300" data-testid="info-card-price">{info.is_free ? "Ücretsiz" : fmtMoney(info.price, cur)}</span>
        </div>
        <span data-testid="info-card-buy-button" className="h-10 rounded-xl cx-btn-primary text-sm inline-flex items-center justify-center gap-2">
          <Eye className="h-4 w-4" /> {info.is_free ? "İncele" : "İncele & Satın Al"}
        </span>
      </div>
    </Link>
  );
}
